import React, { Component } from 'react';
import { PATH } from '../../../../../../../constants';
import { formatNameText } from '../../../../../../../utils/TextHelper';
import './SeekButton.css';

class SeekButton extends Component {
  constructor(props) {
    super(props);

    this.seekClick = this.seekClick.bind(this);
  }

  seekClick() {
    const { data, onVideoSeek } = this.props;
    const seekArr = data.time.split(':');
    const seekTime = Math.round(
      (Number(seekArr[0]) * 60 + Number(seekArr[1])) * 1000
    );
    onVideoSeek(false, seekTime);
  }

  render() {
    const { data } = this.props;
    return (
      <button className="seek-link" type="button" onClick={this.seekClick}>
        <div className="seek-thumb-wrap">
          <img
            className="seek-thumb"
            src={`${PATH.SCREENS}${data.file}.jpg`}
            onError={e => {
              e.target.src = `${PATH.IMG}screen-fallback.jpg`;
            }}
            alt={data.name}
          />
        </div>
        <div className="seek-name">{`${data.time} | ${formatNameText(
          data.name
        )}`}</div>
      </button>
    );
  }
}

export default SeekButton;



// WEBPACK FOOTER //
// ./src/components/App/Okupace/Content/Detail/SeekList/SeekButton/SeekButton.js